export default __webpack_public_path__ + "static/media/NAV-ADAS-main.2845121e.jpg";